



















































































import Vue from 'vue';
import {LogisticTasksItem} from "@/interfaces/LogisticTasksItem";
import {TravelShiftItem} from "@/interfaces/TravelShiftItem";
import GenericModal from '@/componentsReusable/genericModal.vue';
import {BallPulseLoader} from 'vue-loaders';
import { HTTP } from '@/utils/httpCommonUtil';
import { convertDateStringToUTCDate } from '@/utils/dateUtil';
import format from "date-fns/format";

export default Vue.component('invoice-facility-billable', {
  name: 'InvoiceFacilityBillable',
  props: {
    'showLogisticsModal': { type: Boolean, required: true},
    'provider': { type: Object, required: true},
    'shifts': { type: Array, required: true},
    'body-text': {},
    'success-button-text': {},
    'cancel-button-text': {},
    'header-text': {},
    'max-width': {type: String, default: "350px" }
  },
  components: {
    GenericModal,
    // BallPulseLoader isn't actually used but if you remove this line it stops compiling
    BallPulseLoader
  },
  data () {
    return {
      dynamicModalContainer: {'max-width': (this as any).maxWidth},
      logisticTasksItems: [] as LogisticTasksItem[],
      modalStep: 1 as number,
      results: [] as any[],
      travelShifts: [] as TravelShiftItem[],
      note: '',
    };
  },
  computed: {
    findFirstShift (): any {
      this.shifts.sort((a: any, b: any) => ((a.shiftStartDatetime as Date) > (b.shiftStartDatetime as Date)) ? 1 : -1);
      return this.shifts[0];
    },
    selectedTravel (): any {
      return this.logisticTasksItems.some(item => item.logisticTaskId === 1 && item.isNeeded || item.logisticTaskId === 2 && item.isNeeded || item.logisticTaskId === 3 && item.isNeeded);
    },
    atLeastOneItemSelected (): any {
      return !this.logisticTasksItems.some(item => item.isNeeded);
    },
  },
  watch: {
    showLogisticsModal () {
      if (this.showLogisticsModal) {
        this.modalStep = 1;
      }
    }
  },
  async created () {
    this.dynamicModalContainer = {'max-width': (this as any).maxWidth };
    this.getLogisticTasksItems();
    this.getDatesFromShifts(this.shifts);
  },
  methods: {
    getLogisticTasksItems() {
      // TODO: make an api call to the new route and get the logisticNeedsItems for this shift.id, set to this.logisticNeedsItems
      this.logisticTasksItems = [
        {logisticTaskId: 1, title: "Flight", isNeeded: false},
        {logisticTaskId: 2, title: "Rental Car", isNeeded: false},
        {logisticTaskId: 3, title: "Hotel", isNeeded: false},
        {logisticTaskId: 4, title: "Credentials", isNeeded: false},
        {logisticTaskId: 5, title: "Licensing", isNeeded: false},
      ]
    },
    getDatesFromShifts(shifts: any[]) {
      this.travelShifts = shifts.map((shift: any) => ({
        travelShiftId: shift.shiftId,
        shiftDate: format(convertDateStringToUTCDate(shift.shiftStartDatetime) as any, 'MMM DD'),
        isNeeded: false
      }))
    },
    createTasks() {
      if (this.shifts.length > 1 && this.selectedTravel) {
        this.modalStep = 2;
        return;
      }
      this.createTasksAPI([this.findFirstShift.shiftId]);
    },
    createMultipleTasks(){
      const shiftIds = this.travelShifts.filter((item) => item.isNeeded).map((task) => (task.travelShiftId))
      this.createTasksAPI(shiftIds);
    },
    createTasksAPI(travelShiftIds: number[]) {
      const firstShiftId = this.findFirstShift.shiftId
      HTTP.post('api/shift-logistics/', {
        credentials: this.logisticTasksItems[3].isNeeded ? [firstShiftId] : null,
        licensing: this.logisticTasksItems[4].isNeeded ? [firstShiftId] : null,
        travel: {
          flight: this.logisticTasksItems[0].isNeeded,
          carRental: this.logisticTasksItems[1].isNeeded,
          hotel: this.logisticTasksItems[2].isNeeded,
          shiftIds: this.logisticTasksItems[0].isNeeded || this.logisticTasksItems[1].isNeeded || this.logisticTasksItems[2].isNeeded ? travelShiftIds : null
        },
        note: this.note
      }).then((response: any) => {
        this.results = response.data.data;
        this.modalStep = 3;
      }).catch((err: any) => {
        console.log('response Error!');
        console.log(err);
      })
    },
    browseToShift (shiftId: number) {
      window.open("/shifts/" + shiftId, '_blank');
    },
    cancelTaskSelectionModal() {
      this.modalStep = 0;
      this.$emit("close", this.shifts.length);
    },
    clearSelectedTravelTasks() {
      this.logisticTasksItems[0].isNeeded = false;
      this.logisticTasksItems[1].isNeeded = false;
      this.logisticTasksItems[2].isNeeded = false;
    },
    cancelTravelTaskSelectionModal() {
      this.clearSelectedTravelTasks();
      this.createTasksAPI([this.findFirstShift.shiftId]);
    },
    confirmTasksCreated() {
      this.modalStep = 0;
      this.$emit("close");
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/LogisticsTaskCreationModal.vue